import { QrCode } from 'features/settings/qr-code/types';
import { request } from '~/utils/request';

export const getQrCode = request.card<QrCode, QrCode>(async ({ api, parseError }) => {
  const res = await api.get<{ data: QrCode }>('/api/admin/qr-code');
  if (res.error) {
    return { error: parseError(res.error) };
  }
  return { data: res.data.data };
});

const save = (body: QrCode) => {
  const upload = request.custom<any, QrCode>(async ({ api, data }) => await api
    .instance
    .url('/api/admin/qr-code')
    .formData({
      ...data,
    })
    .post()
    .json((response) => (response.code === 200 ? { data: response.data } : { error: response.errors }))
    .catch(({ text }) => {
      const error = JSON.parse(text);

      return {
        error: error.result.errors,
      };
    }) as any);

  return upload(body);
};

export const updateQrCode = request.card(async ({ parseError, data }) => {
  const body: Partial<QrCode> = {};

  if (data.data.image && Array.isArray(data.data.image)) {
    body.image = (data.data.image as File[])[0];
  }

  const res = await save(body as QrCode);

  if (res.error) {
    return { error: parseError?.(res.error) };
  }

  return res;
});

export const deleteQrCode = request.card(async ({ api, parseError }) => {
  const res = await api.delete('/api/admin/qr-code');
  if (res.error) {
    return { error: parseError(res.error) };
  }

  return { data: 'ok' };
});
